import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

/**
 * Entry point for the application
 * Renders the App component into the DOM
 */
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
